import React from 'react';
import PropTypes from 'prop-types';

import moment from 'moment';

import classNames from 'classnames';
import staticStyles from './style';

const DateCell = ({ value, hideTime, nowrap, inLine, red, grey }) => {
  // 使用 moment 解析时间
  const dateValue = value ? moment(value) : null;

  if (!dateValue || !dateValue.isValid()) {
    return <div className="DateCell">---</div>;
  }

  return (
    <div
      className={classNames('DateCell', {
        'DateCell--nowrap': nowrap,
        'DateCell--inLine': inLine,
        'DateCell--red': red,
        'DateCell--grey': grey,
      })}>
      {dateValue.format('MMM DD, YYYY')}
      {!hideTime && <span style={{ color: '#777777', marginLeft: '5px' }}>{dateValue.format(' h:mm A')}</span>}
      <style jsx>{staticStyles}</style>
    </div>
  );
};

DateCell.propTypes = {
  value: PropTypes.string.isRequired,
  hideTime: PropTypes.bool,
  nowrap: PropTypes.bool,
  inLine: PropTypes.bool,
  red: PropTypes.bool,
};

DateCell.defaultProps = {
  hideTime: false,
  nowrap: false,
  inLine: false,
  red: false,
};

export default DateCell;
